// Copyright (C) 2021 Bystronic Laser AG

import { isNil } from '@/utils/misc';
import { getCurrentInstance } from 'vue';

export function useI18n() {
  const instance = getCurrentInstance();

  if (isNil(instance)) {
    throw new Error('useI18n must be called within a setup function');
  }

  /*
   * If this composable is assigned to a constant by destructuring
   * (i.e., const { t } = useI18n();)
   * it seems like "t" loses the reference to "this", and an exception is thrown internally.
   * This is fixed by manually binding instance.proxy.$i18n to the function.
   */
  return {
    t: instance.proxy.$i18n.t.bind(instance.proxy.$i18n),
    tc: instance.proxy.$i18n.tc.bind(instance.proxy.$i18n),
    n: instance.proxy.$i18n.n.bind(instance.proxy.$i18n),
  };
}
